//左侧导航树组件
<template>
  <el-menu class="el-menu-tree" :default-active="activePath"
      @select="selectMenu" ref="navmenu">
    <el-submenu index="1">
      <template slot="title">
        <span>镜像下载</span>
      </template>
      <el-menu-item index="/oem">
        <router-link to="/oem/login">OEM用户下载</router-link>
      </el-menu-item>
<!--      <el-menu-item index="/pcib">-->
<!--        <router-link to="/pcib/snLogin">PCIB用户下载</router-link>-->
<!--      </el-menu-item>-->
      <el-menu-item index="/pcibOrder">
        <router-link to="/pcibOrder/login">订单授权下载</router-link>
      </el-menu-item>
    </el-submenu>
    <el-submenu index="2">
      <template slot="title">
        <span>工具下载</span>
      </template>
      <el-menu-item
        :index="`/public/${item.id}/${item.classify}`"
        v-for="item in toolsMenu"
        :key="item.name"
      >
        <router-link :to="`/public/${item.id}/${item.classify}`">{{item.name}}</router-link>
      </el-menu-item>
    </el-submenu>
    <el-menu-item index="/cmop">
      <router-link to="/cmop/login">开放激活</router-link>
    </el-menu-item>
  </el-menu>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "nav-tree",
  data() {
    return {
      activePath: null
    };
  },
  created() {
    console.log(this.$route);
    this.activePath = "/" + this.$route.path.split("/")[1];
  },
  mounted: function() {
    let self = this;
    let oemReg = /^\/oem/;
    let authReg = /^\/pcib/;
    let toolsReg = /^\/tools/;
    let cmopReg = /^\/cmop/;
    let id = self.$route.path;
    if (oemReg.test(id)) {
      self.treeList[0].isShow = true;
      self.treeList[0].child[0].active = true;
    } else if (authReg.test(id)) {
      self.treeList[0].isShow = true;
      self.treeList[0].child[1].active = true;
    } else if (toolsReg.test(id)) {
      self.treeList[1].isShow = true;
      self.treeList[1].child[0].active = true;
    } else if (cmopReg.test(id)) {
      self.other.active = true;
    }

    this.getToolsClassifyListAction().then(rs => {
      this.toolsMenu = rs.map(child => {
        return {
          active: false,
          id: "tools",
          classify: child.classify,
          name: child.name,
          total: 0
        };
      });
      if (this.activePath === "/public") {
        this.activePath = this.$route.path;
        this.$refs.navmenu.updateActiveIndex(this.activePath);
      }
    });
  },
  watch: {
    $route(to, from) {
      // let self = this;
      // let oemReg = /^\/oem/;
      // let authReg = /^\/pcib/;
      // let toolsReg = /^\/tools/;
      // let id = self.$route.path;
      // if (oemReg.test(id)) {
      //   self.treeList[0].isShow = true;
      //   self.treeList[0].child[0].active = true;
      // } else if (authReg.test(id)) {
      //   self.treeList[0].isShow = true;
      //   self.treeList[0].child[1].active = true;
      // } else if (toolsReg.test(id)) {
      //   self.treeList[1].isShow = true;
      //   self.treeList[1].child[0].active = true;
      // }
      // if (to.params.id === "search") {
      //   self.treeList.forEach(function(item) {
      //     item.child.forEach(function(item) {
      //       item.active = false;
      //     });
      //   });
      //   self.other.active = false;
      // }
      this.activePath = "/" + to.path.split("/")[1];
      this.$refs.navmenu.updateActiveIndex(this.activePath);
    }
  },
  data() {
    return {
      treeList: [
        {
          isShow: false,
          name: "镜像下载",
          child: [
            {
              active: false,
              id: "oem",
              name: "OEM用户下载",
              link_to: "login",
              total: 0
            },
            // {
            //   active: false,
            //   id: "pcib",
            //   name: "批量授权下载",
            //   link_to: "pcibLogin",
            //   total: 0
            // },
            {
              active: false,
              id: "pcibOrder",
              name: "订单授权下载",
              link_to: "pcibOrderLogin",
              total: 0
            }
          ]
        },
        {
          isShow: false,
          name: "工具下载",
          child: [
            // {
            //   active: false,
            //   id: "tools",
            //   name: "激活客户端",
            //   link_to: "public",
            //   total: 0
            // }
          ]
        }
      ],
      other: {
        name: "开放激活",
        link_to: "cmopLogin",
        active: false,
        id: "cmop",
        total: 0
      },
      toolsMenu: []
    };
  },
  computed: {
    ...mapGetters("config", {
      getToolsClassifyList: "getToolsClassifyList"
    })
  },
  methods: {
    openUrl: function(item) {
      if (item.total >= 1) {
        sessionStorage.clear();
        localStorage.clear();
        // window.location.reload();
      }
      this.$router.push({ name: item.link_to, params: { id: item.id } });
    },
    clickParent: function(index) {
      this.treeList[index].isShow = !this.treeList[index].isShow;
    },
    clickChild: function(index, obj) {
      if (obj.active) {
        obj.total++;
      }
      this.treeList.forEach(function(item) {
        item.child.forEach(function(item) {
          item.active = false;
        });
      });
      this.other.active = false;
      obj.active = true;
    },
    selectMenu(index) {
      const pcibs = ["/pcib", "/pcibOrder", "/oem"];
      // if (
      //   index === this.activePath ||
      //   (pcibs.indexOf(index) > -1 && pcibs.indexOf(this.activePath) > -1)
      // ) {
      if (pcibs.indexOf(index) > -1) {
        sessionStorage.clear();
        localStorage.clear();
      }
    },
    ...mapActions("config", {
      getToolsClassifyListAction: "getToolsClassifyListAction"
    })
  }
};
</script>

<!-- 组件的样式不复用 -->
<style scoped lang="scss">
@import "~@/style/base/constant";
@import "~@/style/components/nav_tree";

.el-menu {
  background-color: $bg;
}
.el-menu-tree.el-menu {
  .el-menu-item {
    line-height: 50px;
    background-color: $bg;
  }
  .el-menu-item a {
    display: block;
    width: 100%;
    height: 100%;
    font-size: 1.4rem;
    line-height: 50px;
  }

  .el-submenu__title {
    span {
      font-size: 1.6rem;
    }
  }

  & > li.el-menu-item a {
    font-size: 1.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavTree.vue